<template>
  <div class="homepage-key-statistics__wrapper">
    <h2
      :id="$options.consts.ELEMENT_ID.STATISTICS_SECTION"
      class="homepage-key-statistics__title title"
    >
      ForexLive RSS Feed | Key Statistics
    </h2>

    <p class="homepage-key-statistics__description text-body">
      Explore the key figures that highlight the success and influence of
      ForexLive. These stats tell the story of why we're the go-to source for
      market news.
    </p>

    <homepage-key-statistics-overview />

    <div class="background-cell-pattern" />
  </div>
</template>

<script>
import HomepageKeyStatisticsOverview from '@/components/_sections/_homepage/HomepageKeyStatistics/HomepageKeyStatisticsOverview/index.vue'
import { ELEMENT_ID } from 'enums/element-id'

export default {
  name: 'HomepageKeyStatistics',
  components: { HomepageKeyStatisticsOverview },
  consts: {
    ELEMENT_ID
  }
}
</script>

<style lang="scss" scoped>
.homepage-key-statistics__wrapper {
  position: relative;
  background: $c--coal-black;

  // prevents cell background from above from overlapping with this section
  z-index: 1;

  $padding: (
    $above-desktop-xl: 96px $padding-x-desktop-full-hd,
    $desktop-xl: 96px $padding-x-desktop-xl,
    $tablet: 64px $padding-x-tablet,
    $mobile: 32px $padding-x-mobile
  );

  $margin: (
    $above-desktop-xl: 0 -#{$padding-x-desktop-full-hd},
    $desktop-xl: 0 -#{$padding-x-desktop-xl},
    $tablet: 0 -#{$padding-x-tablet},
    $mobile: 0 -#{$padding-x-mobile}
  );

  @include setStyleByBreakpoint('margin', $margin);
  @include setStyleByBreakpoint('padding', $padding);

  .homepage-key-statistics__description {
    margin-top: 20px;
    color: $c--text-secondary;
    max-width: 800px;
  }

  .background-cell-pattern {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1440px;
    background-position: top;
    pointer-events: none;

    $background-image: (
      $above-desktop-xl: url('/images/background-cell-pattern-5.svg'),
      $desktop-md: url('/images/background-cell-pattern-6.svg'),
      $tablet: url('/images/background-cell-pattern-7.svg'),
      $mobile: url('/images/background-cell-pattern-8.svg')
    );

    @include setStyleByBreakpoint('background-image', $background-image);
  }
}
</style>
